import script from "./UserManage.vue?vue&type=script&setup=true&lang=js"
export * from "./UserManage.vue?vue&type=script&setup=true&lang=js"

import "./UserManage.vue?vue&type=style&index=0&id=1cba372e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1cba372e"]])

export default __exports__